import React, { useState, useEffect } from "react"
import { AlertCircle } from "lucide-react"
import { computeAssessmentPerformance } from "../../../utils/assessmentPerformanceHelpers"
import ScoreDistributionChart from "../../../components/ui/score-distribution-chart"

const AssessmentPerformanceSection = ({ orgId }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    computeAssessmentPerformance(orgId).then((result) => {
      setData(result)
      setLoading(false)
    })
  }, [orgId])

  if (loading || !data) {
    return <div className="h-96 bg-muted rounded-lg animate-pulse mb-6" />
  }

  if (data?.totalCompleted === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-5 mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-1">Assessment Performance</h3>
        <p className="text-sm text-muted-foreground">
          No quiz or capstone attempts yet — this section fills in as learners take assessments.
        </p>
      </div>
    )
  }

  return (
    <div className="bg-card border border-border rounded-lg p-5 mb-6">
      <h3 className="text-lg font-semibold text-foreground mb-5">Assessment Performance</h3>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-background border border-border rounded-lg p-4">
          <p className="text-xs text-muted-foreground mb-1">Assessments Completed</p>
          <p className="text-2xl font-bold text-foreground">{data?.totalCompleted?.toLocaleString()}</p>
        </div>
        <div className="bg-background border border-border rounded-lg p-4">
          <p className="text-xs text-muted-foreground mb-1">Average Score</p>
          <p className="text-2xl font-bold text-foreground">{data?.avgScore}%</p>
        </div>
        <div className="bg-background border border-border rounded-lg p-4">
          <p className="text-xs text-muted-foreground mb-1">Pass Rate</p>
          <p className="text-2xl font-bold text-foreground">{data?.passRate}%</p>
        </div>
      </div>

      <div className="mb-6">
        <p className="text-sm font-medium text-foreground mb-3">Score Distribution</p>
        <ScoreDistributionChart data={data?.distribution} />
      </div>

      <div>
        <p className="text-sm font-medium text-foreground mb-3">Most Challenging Assessments</p>
        <div className="space-y-2">
          {data?.mostChallenging?.map((item) => (
            <div key={item?.title} className="flex items-center justify-between bg-background border border-border rounded-lg px-4 py-2.5">
              <div className="flex items-center gap-2 min-w-0">
                {item?.passRate < 70 && <AlertCircle size={14} className="text-warning shrink-0" />}
                <span className="text-sm text-foreground truncate">{item?.title}</span>
              </div>
              <span className={`text-sm font-semibold shrink-0 ${item?.passRate < 70 ? "text-warning" : "text-foreground"}`}>
                {item?.passRate}% pass rate
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AssessmentPerformanceSection